import React, { forwardRef, ReactNode, useState, useEffect } from 'react';
import { Tab as BaseTab, tabClasses } from '@mui/base';
import { Tabs as BaseTabs } from '@mui/base';
import { TabsList as BaseTabsList, TabPanel as BaseTabPanel } from '@mui/base';
import { buttonClasses } from '@mui/base/Button';
import { styled } from '@mui/system';

const Tab = styled(BaseTab)`
  color: #000;
  cursor: pointer;
  background-color: transparent;
  line-height: 1.5;
  padding: 0.625rem 1.25rem;
  margin-right: 0.625rem;
  border: none;
  display: flex;
  border-bottom: 2px solid transparent;

  &.${tabClasses.selected} {
    border-bottom: 2px solid #ee3134;
  }

  &.${buttonClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const TabPanel = styled(BaseTabPanel)``;

const TabsList = styled(BaseTabsList)(
  ({ theme }) => `
  min-width: 400px;
  margin-bottom: 16px;
  display: flex;
  `
);

export interface TabsProps {
  tabContent: Array<{
    title: string | ReactNode;
    content: ReactNode;
  }>;
  defaultIndex?: number;
  handleChange?: (event: React.ChangeEvent<{}>, newValue: number) => void;
}
const Tabs = forwardRef<HTMLInputElement, TabsProps>(function Tabs(props, ref) {
  const { tabContent, defaultIndex = 0, handleChange } = props;
  const [value, setValue] = useState(defaultIndex);
  useEffect(() => {
    setValue(defaultIndex);
  }, [defaultIndex]);

  const handleChangeClick = (event, newValue) => {
    if (handleChange) {
      handleChange(event, newValue);
    } else {
      setValue(newValue);
    }
  };
  return (
    <BaseTabs value={value} onChange={handleChangeClick}>
      <TabsList className="sm:min-w-fit">
        {tabContent.map((tab, index) => (
          <Tab key={index} value={index}>
            {tab.title}
          </Tab>
        ))}
      </TabsList>
      {tabContent.map((tab, index) => (
        <TabPanel key={index} value={index}>
          {tab.content}
        </TabPanel>
      ))}
    </BaseTabs>
  );
});
export { Tabs };
